import { STYLE_SEMIBOLD_BLUE } from "./useStyle";
import { Storage } from "aws-amplify";
import api from "./useApi";
import { FunctionZeroPad } from "radium-omnibus";
import { initAuth } from "../redux/auth.reducer";
import {
  ContextLanguage,
  PageSaparate,
  PageSaparateEn,
} from "../context/Context.Language";
import React from "react";
import AviableAddress from "./useAviableAddress";
import { DateTime } from "luxon";
import { TIME_THAT_STILL_SAME_DAY_SERVICE } from "./useConstants";

export const FunctionAddOnClickToString = ({ string, where, onClick }) => {
  const { language } = React.useContext(ContextLanguage);

  if (string) {
    const findWhere = String(string).split(where);
    if (findWhere.length > 1) {
      return (
        <div className="">
          <div>
            {findWhere[0]}
            <span className={STYLE_SEMIBOLD_BLUE} onClick={onClick}>
              {where[language]}
            </span>
            {findWhere[1]}
          </div>
        </div>
      );
    } else {
      return string;
    }
    return;
  } else {
    return;
  }
};

export const CloudfrontUrl = "https://d399aco788kd2w.cloudfront.net/public/";

export const BunketUrl =
  "https://bucketlaundry92708-dev.s3.ap-southeast-1.amazonaws.com/public/";

export const FunctionGetDataFromS3 = async (name) => {
  try {
    const dataFromS3 = await fetch(`${BunketUrl}${name}`, {
      cache: "no-store",
    });

    const jsonData = await dataFromS3.json();

    return jsonData;
  } catch (error) {
    console.error("ERROR FunctionGetDataFromS3", error);
  }
};

export const FunctionGetPathUrl = (key) => {
  if (key) {
    return `${CloudfrontUrl}${key}`;
  } else {
    return;
  }
};

export const FunctionGetImageFromS3 = (key) => {
  if (key) {
    return `${BunketUrl}${key}`;
  } else {
    return;
  }
};

export const FunctionUploadFileAws = async (file, key = true) => {
  if (file?.size) {
    const keyUpload = `${key ? new Date().getTime() : ""}${key ? "_" : ""}${
      file?.name
    }`;
    await Storage.put(keyUpload, file);
    return keyUpload;
  } else {
    return file;
  }
};

export const FunctionGetMarker = async (mark, setMarker) => {
  if (mark) {
    const { data } = await api.post("/address/place", {
      lat: mark.lat,
      lng: mark.lng,
    });
    setMarker(data.address.results[0].formatted_address);
  } else {
    return;
  }
};

export const FunctionGetCurrentLocation = async (setCurrentLocation) => {
  try {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(async function (position) {
        let CurrentPosition = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };

        const { data } = await api.post("/address/place", {
          lat: CurrentPosition.lat,
          lng: CurrentPosition.lng,
        });

        CurrentPosition = {
          ...CurrentPosition,
          // raw: data.address.results[0],
          address:
            data?.address?.results[0]?.formatted_address || "Your Location",
        };

        setCurrentLocation(CurrentPosition);
      });
    }
  } catch (error) {
    console.error("FunctionGetLocation", error);
  }
};

export const FunctionGetCurrentLocationApi = async (setCurrentLocation) => {
  try {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(async function (position) {
        let CurrentPosition = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };

        const { data } = await api.post("/address/current", {
          lat: CurrentPosition.lat,
          lng: CurrentPosition.lng,
        });

        CurrentPosition = {
          ...CurrentPosition,
          ...data?.current,
        };

        const isAviliable = FunctionCheckArea(AviableAddress, CurrentPosition);

        if (isAviliable) {
          setCurrentLocation(CurrentPosition);
        } else {
          return;
        }
      });
    }
  } catch (error) {
    console.error("FunctionGetLocation", error);
  }
};

export const FunctionGetLatLng = (link) => {
  try {
    if (!link || null) return "";
    const Current = link?.split("@")?.slice(1, 2)[0]?.split(",")?.slice(0, 2);
    const Location = Current?.length;
    for (let i = 0; i < Location; i++) {
      // const getValue = Current[i];
      // แบบนี้คือ การทำให้มัน . เข้าไปได้
      return { lat: Current[0], lng: Current[1] };
      // แบบนีคือ โยน string ออกไป
      // return {"lat :" + Current[0] + ", lng :" + Current[1]}
    }
  } catch (error) {
    console.error("FunctionGetLatLng", error);
  }
};

export const FunctionGetLinkGoogleMap = (link) => {
  try {
    if (!link || null) return "";
    const link_map = link
      ?.split(`src="`)
      ?.slice(1, 2)[0]
      ?.split(`"`)
      ?.slice(0, 1);
    return link_map;
  } catch (error) {
    console.error("FunctionGetLinkGoogleMap", error);
  }
};

export const FunctionGetDistance = (
  current = { lat: 0, lng: 0 },
  destination = { lat: 0, lng: 0 }
) => {
  try {
    if (!current) return null;
    const Radius = 6378137;
    const MinusLut = ((destination?.lat - current?.lat) * Math.PI) / 180;
    const MinusLng = ((destination?.lng - current?.lng) * Math.PI) / 180;
    const Calcurate =
      Math.sin(MinusLut / 2) * Math.sin(MinusLut / 2) +
      Math.cos((current?.lat * Math.PI) / 180) *
        Math.cos((destination?.lat * Math.PI) / 180) *
        Math.sin(MinusLng / 2) *
        Math.sin(MinusLng / 2);
    const Result =
      2 * Math.atan2(Math.sqrt(Calcurate), Math.sqrt(1 - Calcurate));
    const Distance = Radius * Result;
    const ResultFomat = (Distance / 1000).toFixed(1);
    return ResultFomat;
  } catch (error) {
    console.error("FunctionGetDistance", error);
  }
};

export const FunctionGetUsername = (input) => {
  try {
    if (input) {
      return String(input)?.slice(1, input?.length);
    } else {
      return "";
    }
  } catch (error) {
    console.error("FunctionGetUsername", error);
  }
};

export const FunctionChangeSizeOfShoes = (size) => {
  if (size === "S") {
    return "1 Pair";
  } else if (size === "M") {
    return "2 Pair";
  } else if (size === "L") {
    return "3 Pair";
  } else if (size === "XL") {
    return "4 Pair";
  } else {
    return "ไม่ระบุ";
  }
};

export const FunctionGetDayStringFromDate = (date) => {
  try {
    const day = DateTime.fromISO(date).weekday;
    switch (day) {
      case 0:
        return "Sunday";
      case 1:
        return "Monday";
      case 2:
        return "Tuesday";
      case 3:
        return "Wednesday";
      case 4:
        return "Thursday";
      case 5:
        return "Friday";
      case 6:
        return "Saturday";
      default:
        return "Sunday";
    }
  } catch (error) {
    console.error("FunctionGetDayStringFromDate", error);
  }
};

export const FunctionGetDateNTimeFromDate = (dateInput) => {
  try {
    const day = FunctionGetDayStringFromDate(dateInput);
    const date = DateTime.fromISO(dateInput)
      .setLocale("th")
      .setZone("UTC+7")
      .get("day");
    const month = DateTime.fromISO(dateInput)
      .setLocale("th")
      .setZone("UTC+7")
      .get("month");
    const year = DateTime.fromISO(dateInput)
      .setLocale("th")
      .setZone("UTC+7")
      .get("year");
    const hour = DateTime.fromISO(dateInput)
      .setLocale("th")
      .setZone("UTC+7")
      .get("hour");
    const minute = DateTime.fromISO(dateInput)
      .setLocale("th")
      .setZone("UTC+7")
      .get("minute");

    return {
      day,
      date: FunctionZeroPad(date, 2),
      month: FunctionZeroPad(month, 2),
      year,
      hour: FunctionZeroPad(hour, 2),
      minute: FunctionZeroPad(minute, 2),
    };
  } catch (error) {
    console.error("FunctionGetDateNTimeOrder", error);
  }
};

export const FunctionFormatCurrency = (value) => {
  if (value) {
    try {
      return Number(value)
        .toFixed(2)
        .replace(/\d(?=(\d{3})+\.)/g, "$&,");
    } catch (error) {
      console.error("FunctionFormatCurrency", error);
    }
  } else {
    return "0.00";
  }
};

export const OnClickLogout = (dispatch, navigate, location) => {
  localStorage.clear();
  sessionStorage.clear();
  dispatch(initAuth());

  if (location.pathname === "/" || location.pathname === "/TH") {
    window.location.reload();
  } else {
    // navigate("/");
    window.location.pathname = "/";
  }
};

export const FunctionCloneSetValueToSesstion = (name, setValue, value) => {
  try {
    if (setValue) {
      sessionStorage.setItem(`${name}`, JSON.stringify(value));
      setValue(value);
    }
  } catch (error) {
    console.error("FunctionCloneSetValueToSesstion", error);
  }
};

export const FunctionCloneGetValueToSesstion = (name, setValue) => {
  try {
    if (setValue) {
      const value = JSON.parse(sessionStorage.getItem(`${name}`));
      setValue(value);
    }
  } catch (error) {
    console.error("FunctionCloneGetValueToSesstion", error);
  }
};

export const FunctionGetDataFromSessionStorage = (name) => {
  try {
    const value = JSON.parse(sessionStorage.getItem(`${name}`));
    return value;
  } catch (error) {
    console.error("FunctionGetDataFromSessionStorage", error);
  }
};

export const FunctionCheckArea = (areas, marker) => {
  if (areas && marker) {
    const areasCalcurateDistance = areas?.map((area) => {
      const valueThatAviliable = Number(area.distance) / 1000;
      const howFarFromYou = FunctionGetDistance(
        { lat: marker.lat, lng: marker.lng },
        { lat: area.lat, lng: area.lng }
      );
      return {
        ...area,
        howFarFromYou,
        valueThatAviliable,
        isAviliable: howFarFromYou <= valueThatAviliable,
        value: Number(valueThatAviliable) - Number(howFarFromYou),
      };
    });

    const isAviliable =
      areasCalcurateDistance?.filter((area) => {
        return area.isAviliable;
      })?.length > 0;

    return isAviliable;
  } else {
    return;
  }
};

export const FunctionFormatNewLine = (input) => {
  if (input) {
    const thisInput = String(input)?.split("\n");
    return (
      <div>
        {thisInput?.map((i) => {
          return <div>{i}</div>;
        })}
      </div>
    );
  } else {
    return "";
  }
};

export const FunctionChangeFormatDateAgain = (input_string) => {
  if (input_string) {
    const thisString = String(input_string).split(".");
    return (
      FunctionZeroPad(Number(thisString[1]), 2) +
      "." +
      FunctionZeroPad(Number(thisString[0]), 2) +
      "." +
      FunctionZeroPad(Number(thisString[2]), 4)
    );
  } else {
    return "Error";
  }
};

export const weekdays = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];

export const ARRAY_DATE_WEEK_TH = [
  "วันอาทิตย์",
  "วันจันทร์",
  "วันอังคาร",
  "วันพุธ",
  "วันพฤหัสบดี",
  "วันศุกร์",
  "วันเสาร์",
  "วันอาทิตย์",
];

export function FunctionFormatDateToString(value, language) {
  let dayOfWeek = "";
  // weekdays[
  //   DateTime.fromISO(value).setLocale("th").setZone("UTC+7").get("weekday")
  // ];

  if (language === "TH") {
    dayOfWeek =
      ARRAY_DATE_WEEK_TH[
        DateTime.fromISO(value).setLocale("th").setZone("UTC+7").get("weekday")
      ];
  }
  if (language === "EN") {
    dayOfWeek =
      weekdays[
        DateTime.fromISO(value).setLocale("th").setZone("UTC+7").get("weekday")
      ];
  }

  const month = FunctionZeroPad(
    DateTime.fromISO(value).setLocale("th").setZone("UTC+7").get("month"),
    2
  );

  const dayOfMonth = DateTime.fromISO(value)
    .setLocale("th")
    .setZone("UTC+7")
    .get("day")
    .toString()
    .padStart(2, "0");

  const year = DateTime.fromISO(value)
    .setLocale("th")
    .setZone("UTC+7")
    .get("year");

  const hours = DateTime.fromISO(value)
    .setLocale("th")
    .setZone("UTC+7")
    .get("hour")
    .toString()
    .padStart(2, "0");
  const minutes = DateTime.fromISO(value)
    .setLocale("th")
    .setZone("UTC+7")
    .get("minute")
    .toString()
    .padStart(2, "0");

  return `${dayOfWeek}${
    language === "TH" ? " ที่ " : ","
  } ${dayOfMonth}.${month}.${year}${
    language === "TH" ? " เวลา " : ","
  } ${hours}:${minutes}`;
}

export const FunctionCheckIsBKK = (data) => {
  let BKK = false;

  data.forEach(function (location) {
    if (
      location.types.includes("political") &&
      (location.long_name === "Krung Thep Maha Nakhon" ||
        location.long_name === "Bangkok" ||
        location.long_name === "กรุงเทพมหานคร" ||
        location.long_name === "กรุงเทพฯ" ||
        location.long_name === "กรุงเทพ" ||
        location.long_name === "จ.กรุงเทพ")
    ) {
      BKK = true;
    }
  });

  if (BKK) {
    return "BANGKOK";
  } else {
    return "PATTAYA";
  }
};

export const toISO = (date) => {
  if (date) {
    let thisDate = String(date).split(".");
    thisDate =
      thisDate[2] +
      "-" +
      FunctionZeroPad(thisDate[0], 2) +
      "-" +
      FunctionZeroPad(thisDate[1], 2);
    return DateTime.fromISO(thisDate).setLocale("th").toISO();
  } else {
    return DateTime.now().setZone("UTC+7").toISO();
  }
};

export const toISODate = (date) =>
  DateTime.fromISO(date).setLocale("th").toISODate();

export const toISOTime = (date) =>
  DateTime.fromISO(date).setLocale("th").toISOTime();

export const timestampNow = () => {
  let xt = DateTime.now().setLocale("th").setZone("UTC+7").toISOTime();
  let xd = DateTime.now().setLocale("th").setZone("UTC+7").toISODate();

  let x = xd + "T" + xt.slice(0, 12) + "Z";

  return new Date(x).getTime();
};

export const FunctionCreateTimeNow = () => {
  let xt = DateTime.now().setLocale("th").setZone("UTC+7").toISOTime();
  let xd = DateTime.now().setLocale("th").setZone("UTC+7").toISODate();

  let x = xd + "T" + xt.slice(0, 12) + "Z";

  return x;
};

export const FunctionCreateTimeNowPlusOne = () => {
  let xt = DateTime.now()
    .setLocale("th")
    .setZone("UTC+7")
    .plus({
      days: 1,
    })
    .toISOTime();
  let xd = DateTime.now()
    .setLocale("th")
    .setZone("UTC+7")
    .plus({
      days: 1,
    })
    .toISODate();

  let x = xd + "T" + xt.slice(0, 12) + "Z";

  return x;
};

export const startDate = () => {
  return DateTime.now().setZone("UTC+7").startOf("day").toISO();
};

export const toDateTimeTH = (date) =>
  DateTime.fromISO(date).setLocale("th").toFormat("dd/MM/yyyy - TT");

export const FunctionCreateDay = () => {
  return DateTime.now().setLocale("th").setZone("UTC+7").get("day");
};

export const FucntionCreateDateOfWeeK = () => {
  return DateTime.now().setLocale("th").setZone("UTC+7").get("weekday");
};

export const FunctionCreateDayPlusOne = () => {
  return DateTime.now()
    .setLocale("th")
    .setZone("UTC+7")
    .plus({
      days: 1,
    })
    .get("day");
};

export const FunctionCreateMonth = () => {
  return DateTime.now().setLocale("th").setZone("UTC+7").get("month");
};

export const FunctionCreateYear = () => {
  return DateTime.now().setLocale("th").setZone("UTC+7").get("year");
};

export const FunctionCreateHour = () => {
  return DateTime.now().setLocale("th").setZone("UTC+7").get("hour");
};

export const FunctionCreateMinute = () => {
  return DateTime.now().setLocale("th").setZone("UTC+7").get("minute");
};

export const FunctionCreateDayWithInput = (input) => {
  return DateTime.fromISO(input).setZone("UTC+7").get("day");
};

export function isWithinRange() {
  // Create a new Date object with no arguments

  // Extract the hours and minutes from the Date object
  var hours = FunctionCreateHour();
  var minutes = FunctionCreateMinute();

  // Check if the hours value is less than 11.30
  if (
    hours < TIME_THAT_STILL_SAME_DAY_SERVICE
    // || (hours === 11 && minutes <= 30)
  ) {
    return true;
  } else {
    return false;
  }
}

// export const FunctionChangeToBlueLink = (input) => {
//   let createInput = input;

//   const findValue = createInput.substring(
//     createInput.indexOf("[") + 1,
//     createInput.indexOf("]")
//   );

//   const thisValue = findValue.split(",")[0];
//   const thisPath = findValue.split(",")[1];

//   let element = (
//     <span
//       className="blue-link"
//       onClick={() => {
//         console.log("CLICK", thisPath);
//       }}
//     >
//       {thisValue}
//     </span>
//   );

//   createInput = String(createInput).replace(`[${findValue}]`, `${element}`);

//   return createInput;
// };

// export const FunctionChangeToBlueLink = (input, navigate = false) => {
//   if (input?.length > 0) {
//     let createInput = input;

//     const findValue = createInput.substring(
//       createInput.indexOf("[") + 1,
//       createInput.indexOf("]")
//     );

//     const thisValue = findValue.split(",")[0];
//     const thisPath = findValue.split(",")[1];

//     let element = (
//       <span
//         className="linkblue"
//         onClick={(e) => {
//           e.stopPropagation();
//           if (navigate) {
//             navigate(thisPath);
//           }
//         }}
//       >
//         {thisValue}
//       </span>
//     );

//     let parts = createInput.split(`[${findValue}]`);

//     let result = [];
//     for (let i = 0; i < parts.length - 1; i++) {
//       result.push(parts[i]);
//       result.push(element);
//     }
//     result.push(parts[parts.length - 1]);

//     return result;
//   } else {
//     return "";
//   }
// };

export const FunctionChangeToBlueLink = (input, navigate = false) => {
  if (input) {
    let createInput = input?.split("<br/>")?.join("\n");

    const findValue = createInput?.substring(
      createInput.indexOf("[") + 1,
      createInput.indexOf("]")
    );

    const thisValue = findValue?.split(",")[0];
    const thisPath = findValue?.split(",")[1];

    let element = (
      <span
        className="linkblue"
        onClick={(e) => {
          e.stopPropagation();
          if (navigate) {
            navigate(thisPath);
          }
        }}
      >
        {thisValue}
      </span>
    );

    let parts = createInput.split(`[${findValue}]`);

    let result = [];
    for (let i = 0; i < parts.length - 1; i++) {
      result.push(
        parts[i]
          .split("\n")
          .map((line, i) => <React.Fragment key={i}>{line}</React.Fragment>)
      );
      result.push(element);
    }

    result.push(
      parts[parts.length - 1].split("\n").map((line, i) => (
        <React.Fragment key={i}>
          {line}
          <br />
        </React.Fragment>
      ))
    );

    return result;
  } else {
    return "";
  }
};
export const FunctionChangeToBlueLinkNoBr = (input, navigate = false) => {
  if (input) {
    let createInput = input?.split("<br/>")?.join("\n");

    const findValue = createInput?.substring(
      createInput.indexOf("[") + 1,
      createInput.indexOf("]")
    );

    const thisValue = findValue?.split(",")[0];
    const thisPath = findValue?.split(",")[1];

    let element = (
      <span
        className="linkblue"
        onClick={(e) => {
          e.stopPropagation();
          if (navigate) {
            navigate(thisPath);
          }
        }}
      >
        {thisValue}
      </span>
    );

    let parts = createInput.split(`[${findValue}]`);

    let result = [];
    for (let i = 0; i < parts.length - 1; i++) {
      result.push(
        parts[i]
          .split("\n")
          .map((line, i) => <React.Fragment key={i}>{line}</React.Fragment>)
      );
      result.push(element);
    }

    result.push(
      parts[parts.length - 1]
        .split("\n")
        .map((line, i) => <React.Fragment key={i}>{line}</React.Fragment>)
    );

    return result;
  } else {
    return "";
  }
};

export const FunctionChangeToStrong = (input, navigate = false) => {
  if (input) {
    let createInput = input;
    const findValue = createInput.substring(
      createInput.indexOf("{") + 1,
      createInput.indexOf("}")
    );

    let element = <span className="font-semibold">{findValue}</span>;

    let parts = createInput.split(`{${findValue}}`);

    let result = [];

    for (let i = 0; i < parts.length - 1; i++) {
      result.push(parts[i]);
      result.push(element);
    }
    result.push(parts[parts.length - 1]);

    return result;
  } else {
    return "";
  }
};

export const TriggerFunctionGeToTop = () => {
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
};

export function focusAndOpenKeyboard(el, timeout) {
  if (!timeout) {
    timeout = 100;
  }
  if (el) {
    // Align temp input element approximately where the input element is
    // so the cursor doesn't jump around
    var __tempEl__ = document.createElement("input");
    __tempEl__.style.position = "absolute";
    __tempEl__.style.top = el.offsetTop + 7 + "px";
    __tempEl__.style.left = el.offsetLeft + "px";
    __tempEl__.style.height = 0;
    __tempEl__.style.opacity = 0;
    // Put this temp element as a child of the page <body> and focus on it
    document.body.appendChild(__tempEl__);
    __tempEl__.focus();

    // The keyboard is open. Now do a delayed focus on the target element
    setTimeout(function () {
      el.focus();
      el.click();
      // Remove the temp element
      document.body.removeChild(__tempEl__);
    }, timeout);
  }
}

// Usage example
var myElement = document.getElementById("my-element");
var modalFadeInDuration = 300;
focusAndOpenKeyboard(myElement, modalFadeInDuration); // or without the second argument

export const WhiteSpace = ({ children }) => {
  return (
    <span
      style={{
        whiteSpace: "nowrap",
      }}
    >
      {children}
    </span>
  );
};

export const FunctionChangeHerfLanguage = ({ language, location }) => {
  if (PageSaparateEn?.includes(location?.pathname)) {
    if (location?.pathname === "/") {
      return `/TH`;
    } else {
      return `${location?.pathname}/TH`;
    }
  } else if (PageSaparate?.includes(location?.pathname)) {
    if (location?.pathname === "/TH") {
      return `/`;
    } else {
      return `${location?.pathname.slice(0, -3)}`;
    }
  } else {
    return "#";
  }
};

export function FunctionFormattedData(data) {
  const formattedData = {
    amount_s: data.addon.find((item) => item.size === "S").amount,
    unit_s: data.addon.find((item) => item.size === "S").unit,
    amount_m: data.addon.find((item) => item.size === "M").amount,
    unit_m: data.addon.find((item) => item.size === "M").unit,
    amount_l: data.addon.find((item) => item.size === "L").amount,
    unit_l: data.addon.find((item) => item.size === "L").unit,
    unit_th_s: data.addon.find((item) => item.size === "S").unit_th,
    unit_th_m: data.addon.find((item) => item.size === "M").unit_th,
    unit_th_l: data.addon.find((item) => item.size === "L").unit_th,
  };
  return formattedData;
}

export const GetPhoneNumber = (myPhone = "", countryCode = "") => {
  let newPhone = ""; // Variable to store the phone number without leading zeros
  let checkNumber = false; // Flag to indicate if we have encountered a non-zero digit yet

  for (let i = 0; i < myPhone.length; i++) {
    const myPhoneStr = myPhone[i];

    // Check if the current character is not "0" or if we have encountered a non-zero digit before
    if (myPhoneStr !== "0" || checkNumber) {
      checkNumber = true; // Set the flag to true once we encounter a non-zero digit
      newPhone += myPhoneStr; // Append the non-zero digit (or subsequent digits) to the new phone number
    }
  }

  if (countryCode) {
    return countryCode + newPhone;
  } else {
    return newPhone;
  }
};

export function splitOrNotFor(inputString) {
  // Use regular expression to find the word "or" as a separate word
  const regex = /\bor\b/gi;
  // const regex = new RegExp("\\bor\\b|\\bหรือ\\b", "gi");
  // Split the input string using the regular expression
  const splitArray = inputString.split(regex);

  // Filter out any empty strings in the array (caused by consecutive "or" occurrences)
  const resultArray = splitArray.filter((word) => word.trim() !== "");

  return resultArray;
}

export function splitOrTh(inputString) {
  // Use regular expression to find the word "or" as a separate word
  // const regex = new RegExp("\\bor\\b|\\bหรือ\\b", "gi");
  // Split the input string using the regular expression
  const splitArray = inputString.split("หรือ");

  // Filter out any empty strings in the array (caused by consecutive "or" occurrences)
  const resultArray = splitArray.filter((word) => word.trim() !== "");

  return resultArray;
}

// export function splitOrNotFor(inputString) {
//   // Use regular expressions to find the word "or" and "หรือ" as separate words
//   const regexOr = /\bor\b/gi;
//   const regexหรือ = /\bหรือ\b/gi;

//   // Split the input string using the regular expressions
//   const splitArrayOr = inputString.split(regexOr);
//   const splitArrayหรือ = inputString.split(regexหรือ);

//   // Concatenate the two arrays to get the final result
//   const resultArray = splitArrayOr
//     .concat(splitArrayหรือ)
//     .filter((word) => word.trim() !== "");

//   return resultArray;
// }
